import React from 'react'
import {
    Table,
    Button, Container,
    Row, Col, Label, Input
} from 'reactstrap'
import '../css/QuoteViewController.css'
import DateTextField from '../view/DateTextField'
import DropDownTextField from '../view/DropDownTextField'
import NumberTextField from '../view/NumberTextField'
import { AddressViewController } from './AddressViewController'
import { getQuotes } from '../model/request/quotes'
import { downloadPurchaseOrderWithId } from '../model/request/pdf'
import {
    searchItems,
    createPurchaseOrder,
    getPurchaseOrder,
    updatePurchaseOrder,
    searchPurchaseOrders,
} from '../model/request/purchase_order'
import { AddressModel } from '../model/AddressModel'
import { SearchModel } from '../model/SearchModel'
import { PurchaseOrder } from '../model/PurchaseOrder'
import { PurchaseOrderItem } from '../model/PurchaseOrderItem'
import { Account } from '../model/Account'
import { formatAsDollarValue, moneyText } from '../model/Formatting'

class PurchaseOrderRequestViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        const account = Account.fromCookieAndLocalStorage()
        const po = new PurchaseOrder()
        po.order_by = account.first_name + ' ' + account.last_name
        this.state = {
            'account': account,
            'purchase_order': props.id ? null : po,
            'search_items': [],
            'search_quotes': [],
            'search_vendors': [],
        }
    }

    componentDidMount() {
        if (!this.props.id) {
            return
        }

        this.props.turnOnLoader()
        getPurchaseOrder(this.props.id).then(
            (purchase_order) => {
                this.setState({
                    'purchase_order': purchase_order,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }


    // MARK: View

    renderLabelAndView(label, view) {
        return <Container>
            <Row>
                <Col><Label
                    style={{
                        'fontSize': '20pt',
                        'fontWeight': '400',
                    }}
                >{label}</Label></Col>
            </Row>
            <Row>
                <Col>{view}</Col>
            </Row>
        </Container>
    }

    renderInputWithSuggestions(value, suggestion, maxSuggestionsShown=10, onUpdate) {
        if (maxSuggestionsShown > 0) {
            suggestion = suggestion.slice(0, maxSuggestionsShown)
        }
        return <DropDownTextField
            alwaysDisplayValues={true}
            value={value}
            values={suggestion}
            onChange={(e) => {
                onUpdate(e.target.value)
            }}
            onClickRow={(value, valueIndex) => {
                onUpdate(value)
            }} />
    }

    render() {
        if (!this.state.purchase_order) {
            return <Container>
                <Row>
                    <Col><Label>Loading...</Label></Col>
                </Row>
            </Container>
        }
        return (
            <Container>
                <Row>
                    <Col>
                        {this.renderLabelAndView(
                            'Vendor',
                            <DropDownTextField
                                alwaysDisplayValues={true}
                                value={this.state.purchase_order.vendor_name}
                                values={
                                    this.state.search_vendors
                                    .map((x) => x.vendor_name)
                                }
                                onChange={(e) => {
                                    this.setState({
                                        purchase_order: { ...this.state.purchase_order, vendor_name: e.target.value },
                                    })

                                    searchPurchaseOrders({
                                        'like_vendor_name': '%' +
                                            e.target.value.split('').join('%') +
                                            '%'
                                    }).then(
                                        (purchase_orders) => {
                                            this.setState({
                                                'search_vendors': purchase_orders,
                                            })
                                        }
                                    )
                                }}
                                onClickRow={(value, valueIndex) => {
                                    const po = this.state.search_vendors[valueIndex]
                                    this.setState({
                                        purchase_order: {
                                            ...this.state.purchase_order,
                                            vendor_name: po.vendor_name,
                                            vendor_shipping_address: po.vendor_shipping_address,
                                        },
                                    })
                                }} />
                        )}
                    </Col>
                    <Col>
                        {this.renderLabelAndView(
                            'Terms',
                            this.renderInputWithSuggestions(
                                this.state.purchase_order.terms,
                                [
                                    'Credit Card',
                                    'C.O.D',
                                    'Net 30',
                                    'Net 60',
                                ].filter((x) =>
                                    x.toLowerCase().substr(0, this.state.purchase_order.terms.length)
                                        === this.state.purchase_order.terms.toLowerCase(),
                                ),
                                4,
                                (value) => {
                                    this.setState({
                                        purchase_order: { ...this.state.purchase_order, terms: value },
                                    })
                                },
                            )
                        )}
                    </Col>
                    <Col>
                        {this.renderLabelAndView(
                            'Expected Order Date',
                            <DateTextField
                                value={this.state.purchase_order.expected_order_date}
                                showModal={this.props.showModal}
                                closeModal={this.props.closeModal}
                                onChange={(newDate) => {
                                    this.setState({
                                        purchase_order: { ...this.state.purchase_order, expected_order_date: newDate },
                                    })
                                }}
                            />
                        )}
                    </Col>
                </Row>
                <Row
                    style={{
                        'marginTop': '30px',
                    }}
                >
                    <Col>
                        {this.renderLabelAndView(
                            'Ship Via',
                            this.renderInputWithSuggestions(
                                this.state.purchase_order.ship_via,
                                [
                                    'Fed EX', 'UPS', 'USPS',
                                    'Royal Mail', 'Flat Rate',
                                    'Air Cargo', 'Expedited',
                                    'Mail',
                                ].filter((x) =>
                                    x.toLowerCase().substr(0,this.state.purchase_order.ship_via.length)
                                    === this.state.purchase_order.ship_via.toLowerCase(),
                                ),
                                4,
                                (value) => {
                                    this.setState({
                                        purchase_order: { ...this.state.purchase_order, ship_via: value },
                                    })
                                },
                            )
                        )}
                    </Col>
                    <Col>
                        {this.renderLabelAndView(
                            'Ordered By',
                            <Input
                                type='text'
                                value={this.state.purchase_order.order_by}
                                onChange={(e) => {
                                    this.setState({
                                        purchase_order: { ...this.state.purchase_order, order_by: e.target.value },
                                    })
                                }}
                            />
                        )}
                    </Col>
                    <Col>
                        {this.renderLabelAndView(
                            'Expected Delivery Date',
                            <DateTextField
                                value={this.state.purchase_order.expected_delivery_date}
                                showModal={this.props.showModal}
                                closeModal={this.props.closeModal}
                                onChange={(newDate) => {
                                    this.setState({
                                        purchase_order: { ...this.state.purchase_order, expected_delivery_date: newDate },
                                    })
                                }}
                            />
                        )}
                    </Col>
                </Row>
                <Row
                    style={{
                        'marginTop': '30px',
                    }}
                >
                    <Col>
                        <div
                            style={{
                                'overflowX': 'auto'
                            }}
                        >
                            <Table>
                                <thead>
                                    <tr>
                                        <th className="text-center label-weight"
                                            style={{'minWidth': '200px'}}>Item #</th>
                                        <th className="text-center label-weight"
                                            style={{'minWidth': '200px'}}>Description</th>
                                        <th className="text-center label-weight"
                                            style={{'minWidth': '200px'}}>Job Name</th>
                                        <th className="text-center label-weight"
                                            style={{'minWidth': '200px'}}>Quantity</th>
                                        <th className="text-center label-weight"
                                            style={{'minWidth': '200px'}}>Unit Price</th>
                                        <th className="text-center label-weight"
                                            style={{'minWidth': '200px'}}>Line Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.purchase_order.items.map((item, index) => {
                                        return <tr>
                                            <td>
                                                <Input
                                                    value={item.item_number}
                                                    onChange={(e) => {
                                                        const items = [...this.state.purchase_order.items]
                                                        items[index] = PurchaseOrderItem.from({ ...items[index], item_number: e.target.value })
                                                        this.setState({ purchase_order: { ...this.state.purchase_order, items } })
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <DropDownTextField
                                                    value={item.description}
                                                    values={this.state.search_items.map((x) => x.description)}
                                                    onChange={(e) => {
                                                        const items = [...this.state.purchase_order.items]
                                                        items[index] = PurchaseOrderItem.from({ ...items[index], description: e.target.value })
                                                        this.setState({ purchase_order: { ...this.state.purchase_order, items } })

                                                        searchItems(e.target.value).then(
                                                            (items) => {
                                                                this.setState({
                                                                    'search_items': items,
                                                                })
                                                            }
                                                        )
                                                    }}
                                                    onClickRow={(value, valueIndex) => {
                                                        const newItem = this.state.search_items[valueIndex]
                                                        const items = [...this.state.purchase_order.items]
                                                        items[index] = PurchaseOrderItem.from(newItem)
                                                        this.setState({ purchase_order: { ...this.state.purchase_order, items } })
                                                    }} />
                                            </td>
                                            <td>
                                                <DropDownTextField
                                                    value={item.job_name}
                                                    values={
                                                        this.state.search_quotes.map((x) => x.job_name)
                                                    }
                                                    onChange={(e) => {
                                                        const items = [...this.state.purchase_order.items]
                                                        items[index] = PurchaseOrderItem.from({ ...items[index], job_name: e.target.value, quote_id: null })
                                                        this.setState({ purchase_order: { ...this.state.purchase_order, items } })

                                                        getQuotes(
                                                            SearchModel.from({
                                                                'job_name': e.target.value,
                                                            })
                                                        ).then(
                                                            (result) => {
                                                                this.setState({
                                                                    'search_quotes': result.data.quotes,
                                                                })
                                                            }
                                                        )
                                                    }}
                                                    onClickRow={(value, valueIndex) => {
                                                        const newQuote = this.state.search_quotes[valueIndex]
                                                        const items = [...this.state.purchase_order.items]
                                                        items[index] = PurchaseOrderItem.from({ ...items[index], job_name: newQuote.job_name, quote_id: newQuote.quote_id })
                                                        this.setState({ purchase_order: { ...this.state.purchase_order, items } })
                                                    }} />
                                            </td>
                                            <td>
                                                <NumberTextField
                                                    style={{
                                                        'textAlign': 'right',
                                                    }}
                                                    showDigitsKeyPad={
                                                        this.state.account.settings.numbers_calculator_show
                                                    }
                                                    value={item.quantity}
                                                    onChange={(e) => {
                                                        const items = [...this.state.purchase_order.items]
                                                        items[index] = PurchaseOrderItem.from({ ...items[index], quantity: e.target.value })
                                                        this.setState({ purchase_order: { ...this.state.purchase_order, items } })
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <NumberTextField
                                                    style={{
                                                        'textAlign': 'right',
                                                    }}
                                                    showDigitsKeyPad={
                                                        this.state.account.settings.numbers_calculator_show
                                                    }
                                                    value={item.unit_price}
                                                    onChange={(e) => {
                                                        const items = [...this.state.purchase_order.items]
                                                        items[index] = PurchaseOrderItem.from({ ...items[index], unit_price: e.target.value })
                                                        this.setState({ purchase_order: { ...this.state.purchase_order, items } })
                                                    }}
                                                />
                                            </td>
                                            <td
                                                style={{
                                                    'textAlign': 'right',
                                                }}
                                            >
                                                <Label><span text={moneyText(item.total())}>{formatAsDollarValue(item.total())}</span></Label>
                                            </td>
                                        </tr>
                                    })}
                                <tr>
                                    <td/>
                                    <td/>
                                    <td
                                        style={{
                                            'textAlign': 'right',
                                        }}
                                    >
                                        <Label>{
                                            this.state.purchase_order.items.sum(
                                                (x) =>
                                                Number.parseFloat(x.quantity)
                                            ).toLocaleString()}
                                        </Label>
                                    </td>
                                    <td
                                        style={{
                                            'textAlign': 'right',
                                        }}
                                    >
                                        <Label>{(() => {
                                            const avg = this.state.purchase_order.items.sum(
                                                    (x) => Number.parseFloat(x.total())
                                                ) /
                                                this.state.purchase_order.items.sum((x) => Number.parseFloat(x.quantity))
                                            return <span text={moneyText(avg)}>{formatAsDollarValue(avg)}</span>
                                        })()}</Label>
                                    </td>
                                    <td
                                        style={{
                                            'textAlign': 'right',
                                        }}
                                    >
                                        <Label>{(() => {
                                            const total = this.state.purchase_order.items.sum((x) => x.total())
                                            return <span text={moneyText(total)}>{formatAsDollarValue(total)}</span>
                                        })()}</Label>
                                    </td>
                                </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Container style={{'paddingRight': '24px', 'textAlign': 'right'}}>
                            <Button color='success' onClick={(e) => {
                                this.setState({
                                    purchase_order: {
                                        ...this.state.purchase_order,
                                        items: [...this.state.purchase_order.items, new PurchaseOrderItem()],
                                    },
                                })
                            }}>Add Item</Button>
                        </Container>
                    </Col>
                </Row>
                <Row>
                    <Col
                        xs='12' sm='6' md='4'
                    >
                        {this.renderLabelAndView(
                            'Sub Total',
                            <Label>
                                {(() => {
                                    const total = this.state.purchase_order.items.sum((x) => x.total())
                                    return <span text={moneyText(total)}>{formatAsDollarValue(total)}</span>
                                })()}
                            </Label>
                        )}
                    </Col>
                    <Col
                        xs='12' sm='6' md='4'
                    >
                        {this.renderLabelAndView(
                            'Sales Tax',
                            <NumberTextField
                                style={{
                                    'textAlign': 'right',
                                }}
                                showDigitsKeyPad={
                                    this.state.account.settings.numbers_calculator_show
                                }
                                value={this.state.purchase_order.sales_tax}
                                onChange={(e) => {
                                    this.setState({
                                        purchase_order: { ...this.state.purchase_order, sales_tax: e.target.value },
                                    })
                                }}
                            />
                        )}
                    </Col>
                    <Col
                        xs='12' sm='6' md='4'
                    >
                        {this.renderLabelAndView(
                            'Shipping Charge',
                            <NumberTextField
                                style={{
                                    'textAlign': 'right',
                                }}
                                showDigitsKeyPad={
                                    this.state.account.settings.numbers_calculator_show
                                }
                                value={this.state.purchase_order.shipping_charge}
                                onChange={(e) => {
                                    this.setState({
                                        purchase_order: { ...this.state.purchase_order, shipping_charge: e.target.value },
                                    })
                                }}
                            />
                        )}
                    </Col>
                    <Col
                        xs='12' sm='6' md='4'
                    >
                        {this.renderLabelAndView(
                            'Discount',
                            <NumberTextField
                                style={{
                                    'textAlign': 'right',
                                }}
                                showDigitsKeyPad={
                                    this.state.account.settings.numbers_calculator_show
                                }
                                value={this.state.purchase_order.discount}
                                onChange={(e) => {
                                    this.setState({
                                        purchase_order: { ...this.state.purchase_order, discount: e.target.value },
                                    })
                                }}
                            />
                        )}
                    </Col>
                    <Col
                        xs='12' sm='6' md='4'
                    >
                        {this.renderLabelAndView(
                            'Total',
                            <Label>
                                {(() => {
                                    const total = this.state.purchase_order.items.sum((x) => x.total()) +
                                        Number.parseFloat(this.state.purchase_order.sales_tax) +
                                        Number.parseFloat(this.state.purchase_order.shipping_charge) -
                                        Number.parseFloat(this.state.purchase_order.discount)
                                    return <span text={moneyText(total)}>{formatAsDollarValue(total)}</span>
                                })()}
                            </Label>
                        )}
                    </Col>
                </Row>
                <Row
                    style={{
                        'marginTop': '30px',
                    }}
                >
                    <Col>
                        <Button
                            onClick={() => {
                                this.setState({
                                    purchase_order: {
                                        ...this.state.purchase_order,
                                        asante_shipping_address: AddressModel.from({
                                            first_name: this.state.account.first_name,
                                            last_name: this.state.account.last_name,
                                            company: 'Asante Sign Group',
                                            street_address: '144 Harrison Street',
                                            city: 'Fort Johnson',
                                            state: 'NY',
                                            zip: '12095',
                                        }),
                                    },
                                })
                            }}
                        >Upper Building</Button>
                    </Col>
                    <Col>
                        <Button
                            onClick={() => {
                                this.setState({
                                    purchase_order: {
                                        ...this.state.purchase_order,
                                        asante_shipping_address: AddressModel.from({
                                            first_name: this.state.account.first_name,
                                            last_name: this.state.account.last_name,
                                            company: 'Asante Sign Group',
                                            street_address: '144 Harrison Street',
                                            city: 'Fort Johnson',
                                            state: 'NY',
                                            zip: '12095',
                                        }),
                                    },
                                })
                            }}
                        >Lower Building</Button>
                    </Col>
                </Row>
                <Row
                    style={{
                        'marginTop': '30px',
                    }}
                >
                    <Col>
                        <Container>
                            <AddressViewController
                                title={'Asante Shipping Address'}
                                model={this.state.purchase_order.asante_shipping_address}
                                onUpdate={(fieldName, value) => {
                                    this.setState({
                                        purchase_order: {
                                            ...this.state.purchase_order,
                                            asante_shipping_address: AddressModel.from({
                                                ...this.state.purchase_order.asante_shipping_address,
                                                [fieldName]: value,
                                            }),
                                        },
                                    })
                                }} />
                        </Container>
                    </Col>
                </Row>
                <Row
                    style={{
                        'marginTop': '30px',
                    }}
                >
                    <Col>
                        <Container>
                            <AddressViewController
                                title={'Vendor Shipping Address'}
                                model={this.state.purchase_order.vendor_shipping_address}
                                onUpdate={(fieldName, value) => {
                                    this.setState({
                                        purchase_order: {
                                            ...this.state.purchase_order,
                                            vendor_shipping_address: AddressModel.from({
                                                ...this.state.purchase_order.vendor_shipping_address,
                                                [fieldName]: value,
                                            }),
                                        },
                                    })
                                }} />
                        </Container>
                    </Col>
                </Row>
                <Row
                    style={{
                        'marginTop': '30px',
                        'marginBottom': '30px',
                    }}
                >
                    <Col>
                        {this.renderLabelAndView(
                            'Notes',
                                <Input
                                    type="textarea"
                                    value={this.state.purchase_order.notes}
                                    onChange={(e) => {
                                        this.setState({
                                            purchase_order: { ...this.state.purchase_order, notes: e.target.value },
                                        })
                                    }}
                                    style={{
                                        'width': '100%',
                                        'height': '200px'
                                    }} />
                        )}
                        </Col>
                </Row>
                <Row
                    className='quote-bottom-bottons-row'
                    xs="1"
                    sm="4"
                >
                    <Col>
                        <Container>
                            <Button
                                color="success"
                                size="lg"
                                className="default-weight purchase-button"
                                onClick={(e) => {
                                    this.props.turnOnLoader()
                                    const poData = {
                                        'id': this.state.purchase_order.id,
                                        'vendor_name': this.state.purchase_order.vendor_name,
                                        'terms': this.state.purchase_order.terms,
                                        'asante_shipping_address': this.state.purchase_order.asante_shipping_address,
                                        'vendor_shipping_address': this.state.purchase_order.vendor_shipping_address,
                                        'expected_order_date':
                                            this.state.purchase_order.expected_order_date,
                                        'ship_via': this.state.purchase_order.ship_via,
                                        'order_by': this.state.purchase_order.order_by,
                                        'expected_delivery_date':
                                            this.state.purchase_order.expected_delivery_date,
                                        'items': this.state.purchase_order.items,
                                        'sub_total':
                                            this.state.purchase_order.items.sum((x) => x.total()),
                                        'sales_tax': this.state.purchase_order.sales_tax,
                                        'shipping_charge': this.state.purchase_order.shipping_charge,
                                        'discount': this.state.purchase_order.discount,
                                        'notes': this.state.purchase_order.notes,
                                    }

                                    let f = this.state.purchase_order.id
                                        ? updatePurchaseOrder
                                        : createPurchaseOrder
                                    f(poData).then(
                                        (purchase_order) => {
                                            this.setState({
                                                purchase_order: { ...this.state.purchase_order, id: purchase_order.id },
                                            })
                                            this.props.turnOffLoader()
                                        },
                                        (error) => {
                                            this.props.showError(error)
                                            this.props.turnOffLoader()
                                        }
                                    )
                                }}
                             >{this.state.purchase_order.id
                                ? 'Update Purchase Order'
                                : 'Create Purchase Order'
                             }</Button>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Button
                                color="secondary"
                                size="lg"
                                className="default-weight purchase-button"
                                disabled={!this.state.purchase_order.id}
                                onClick={(e) => {
                                    downloadPurchaseOrderWithId(
                                        this.state.purchase_order.id,
                                    )
                                }}
                             >Download PDF</Button>
                        </Container>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default PurchaseOrderRequestViewController
